<template>
  <div
    :style="[
      element.style.marginTop
        ? { paddingTop: element.style.marginTop }
        : { marginTop },
      element.style.marginRight
        ? { paddingRight: element.style.marginRight }
        : { marginRight },
      element.style.marginBottom
        ? { paddingBottom: element.style.marginBottom }
        : { marginBottom },
      element.style.marginLeft
        ? { paddingLeft: element.style.marginLeft }
        : { marginLeft },
    ]"
  >
    <bloc-donnees-placeholder v-if="!!!element.childElements.length" />
    <table v-else-if="getFicheInfo()" class="bloc-donnees w-100">
      <draggable
        tag="tbody"
        handle=".data-move-action"
        @change="handleDrag(element.childElements)"
        :list="element.childElements"
        group="colonneEdit"
      >
        <tr
          class="bloctr"
          v-on-clickaway="away"
          v-for="(data, index) in element.childElements"
          :key="'data-' + data.key"
        >
          <td
            @click.stop="toggleCurrentColumn(data.key, $event, 'column', index)"
          >
            <div class="handle-wrapper">
              <div
                class="the-handle"
                style="left: unset; right: -69px; top: -1px"
                :class="{ show: colselected === data.key }"
              >
                <button @click="deleteData(index)">
                  <font-awesome-icon :icon="['fas', 'trash']" /></button
                ><button>
                  <font-awesome-icon
                    class="data-move-action"
                    :icon="['fas', 'expand-arrows-alt']"
                  />
                </button>
              </div>

              <span
                @click.stop="
                  toggleCurrentColumn(data.key, $event, 'column', index)
                "
                tabindex="0"
                style="line-height: 21px !important"
                :id="
                  'column-drop-' +
                  conIndex +
                  '-' +
                  colIndex +
                  '-' +
                  elindex +
                  '-' +
                  index
                "
                class="cedit"
                :class="{ thecolselected: colselected === data.key }"
                >{{ getFicheInfo().mappedHeaderKeys[data.key] }}</span
              >
            </div>
          </td>
          <!--          <td v-else>-->
          <!--            <div class="the-handle" style="left: unset; right:-69px;top: -1px;" :class="{show:colselected === data.key}" v-if="getFicheInfo().mappedHeaderKeys[data.key] !== 'Dénomination'">-->
          <!--              <button @click="deleteData(index)"><font-awesome-icon :icon="['fas', 'trash']" /></button><button><font-awesome-icon class="data-move-action" :icon="['fas', 'expand-arrows-alt']" /></button>-->
          <!--            </div>-->
          <!--            <span class="d-flex px-1 cedit" :id="'column-drop-' + conIndex + '-' + colIndex + '-' + elindex + '-' + index " :class="{thecolselected:colselected === data.key}" @click="toggleCurrentColumn(data.key, $event, 'column', index)" :style="formatStyle(element.style.column)">{{ getFicheInfo().mappedHeaderKeys[data.key] }}</span>-->
          <!--          </td>-->
          <td>
            <div class="handle-wrapper">
              <div class="the-handle">
                <button @click="deleteData(index)" class="delete-btn">
                  <font-awesome-icon
                    :icon="['fas', 'trash']"
                    class="delete-btn"
                  /></button
                ><button>
                  <font-awesome-icon
                    class="data-move-action"
                    :icon="['fas', 'expand-arrows-alt']"
                  />
                </button>
              </div>

              <div
                class="bloc-value"
                @click.stop="
                  toggleCurrentColumn(data.key, $event, 'value', index)
                "
              >
                <span
                  :id="
                    'value-drop-' +
                    conIndex +
                    '-' +
                    colIndex +
                    '-' +
                    elindex +
                    '-' +
                    index
                  "
                  class="cedit"
                  :class="{ thecolselected: valselected === data.key }"
                  :contenteditable="contentEditable"
                  @keyup.exact.enter="handleDataValueChange(data.key)"
                  @blur="handleDataValueChange(data.key)"
                  :ref="`input-${data.key}`"
                >
                  <span v-if="data.key[0] === 'C' || data.key[0] === 'P'">
                    {{
                      getFicheInfo().espaceData[data.key]
                        ? getFicheInfo().espaceData[data.key]
                        : ""
                    }}
                  </span>
                  <span v-else>
                    {{
                      getFicheInfo().espaceData[data.key]
                        ? parseData(getFicheInfo().espaceData[data.key])
                        : "" | format(getFicheInfo().dataFormat[data.key])
                    }}
                    {{ " " + getFicheInfo().dataUnit[data.key] }}
                  </span>
                </span>
              </div>
              <!--              <div v-else>-->
              <!--                <span class="d-flex">-->
              <!--                  {{ getFicheInfo().espaceData[data.key] ? getFicheInfo().espaceData[data.key] : '' | format(getFicheInfo().dataFormat[data.key]) }}{{ ' ' + getFicheInfo().dataUnit[data.key]  }}-->
              <!--                </span>-->
              <!--              </div>-->
            </div>
          </td>
        </tr>
      </draggable>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import blocDonneesPlaceholder from "./blocDonneesPlaceholder";
import { defaultBlocElementStyle } from "../../../config/constanteUse";
import { directive as onClickaway } from "vue-clickaway";
import draggable from "vuedraggable";
import { eventBus } from "../../../main";
import { removeHtmlTag } from "../../../utils/util";

export default {
  components: {
    blocDonneesPlaceholder,
    draggable,
  },
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
    elindex: Number,
    conIndex: Number,
    colIndex: Number,
  },
  mounted() {
    for (let i = 0; i < this.element.childElements.length; i++) {
      if (this.element.childElements[i].valStyle) {
        for (var vStyle in this.element.childElements[i].valStyle) {
          if (
            document.getElementById(
              "value-drop-" +
                this.conIndex +
                "-" +
                this.colIndex +
                "-" +
                this.elindex +
                "-" +
                i
            )
          ) {
            document.getElementById(
              "value-drop-" +
                this.conIndex +
                "-" +
                this.colIndex +
                "-" +
                this.elindex +
                "-" +
                i
            ).style[vStyle] = this.element.childElements[i].valStyle[vStyle];
          }
        }
      }

      if (this.element.childElements[i].colStyle) {
        for (var cStyle in this.element.childElements[i].colStyle) {
          if (
            document.getElementById(
              "column-drop-" +
                this.conIndex +
                "-" +
                this.colIndex +
                "-" +
                this.elindex +
                "-" +
                i
            )
          ) {
            document.getElementById(
              "column-drop-" +
                this.conIndex +
                "-" +
                this.colIndex +
                "-" +
                this.elindex +
                "-" +
                i
            ).style[cStyle] = this.element.childElements[i].colStyle[cStyle];
          }
        }
      }
    }
  },
  created() {
    var myValueStyle = {};
    var myColStyle = {};

    eventBus.$on("applyBlocContentStyle", (data) => {
      var theIndex = data.index;
      data.data.childElements[data.index].valStyle = {};
      data.data.childElements[data.index].colStyle = {};

      for (var style in data.valueStyle[data.context]) {
        if (
          document.getElementById(
            data.context +
              "-drop-" +
              data.conindex +
              "-" +
              data.colindex +
              "-" +
              data.elindex +
              "-" +
              data.index
          )
        ) {
          document.getElementById(
            data.context +
              "-drop-" +
              data.conindex +
              "-" +
              data.colindex +
              "-" +
              data.elindex +
              "-" +
              data.index
          ).style[style] = data.valueStyle[data.context][style];
        }
      }

      if (data.valStyle) {
        // var valStyle = '{' + data.valStyle.slice(0, -1) + '}'
        // console.log(JSON.parse(valStyle))
        // data.data.childElements[data.index].valStyle = data.valStyle

        for (var v in data.valStyle) {
          data.data.childElements[data.index].valStyle[v] = data.valStyle[v];
        }
      }

      if (data.colStyle) {
        // var colStyle ='{' + data.colStyle.slice(0, -1) + '}'
        // console.log(JSON.parse(colStyle))
        // for (var col in data.colStyle) {
        //   data.data.childElements[data.index].colStyle[col] = data.colStyle[col]
        // }

        for (var c in data.colStyle) {
          data.data.childElements[data.index].colStyle[c] = data.colStyle[c];
        }
      }

      this.tConIndex = data.conindex;
      this.tColIndex = data.colindex;
      this.tElIndex = data.elindex;

      this.handleElementUpdate(data.data);
    });
  },
  data() {
    return {
      ...defaultBlocElementStyle,
      contentEditable: false,
      selected: null,
      deletedData: [],
      updatedValue: {},
      changedValue: [],
      valueStyle: [],
      tempIndex: null,
      tConIndex: null,
      tColIndex: null,
      tElIndex: null,
      colselected: null,
      colSelected: null,
      valselected: null,
    };
  },
  filters: {
    format(value, displayFormat) {
      function formatNumber(n, dp = 2) {
        let e = "";
        let s = e + n;
        let l = s.length;
        let b = n < 0 ? 1 : 0;
        let i = s.lastIndexOf(".");
        if (i === -1) {
          dp = 0;
        }
        let j = i === -1 ? l : i;
        let r = e;
        let d = s.substr(j + 1, dp);
        while ((j -= 3) > b) {
          r = " " + s.substr(j, 3) + r;
        }
        const formated =
          s.substr(0, j + 3) +
          r +
          (dp
            ? "." + d + (d.length < dp ? "00000".substr(0, dp - d.length) : e)
            : e);
        console.log("formated=", formated);
        return formated;
      }
      if (displayFormat === "none") {
        return value;
      } else {
        return formatNumber(value);
      }
    },
  },
  methods: {
    ...mapGetters(["getFicheInfo", "isProjectTemplate"]),
    ...mapActions([
      "syncDataValue",
      "setAddedToFiche",
      "overwriteDroppedHeader",
      "addDeletedHeader",
      "updateElement",
    ]),
    parseData(value) {
      var el = document.createElement("div");
      el.innerHTML = value;
      return el.textContent;
    },
    deselectTitle() {
      this.colselected = null;

      document
        .getElementById("col-" + this.conIndex + "-" + this.colIndex)
        .classList.remove("temp-bloc-deselect");
      document
        .getElementById("col-" + this.conIndex + "-" + this.colIndex)
        .classList.remove("temp-col-deselect");
    },
    focusCol() {
      if (this.$route.name === "edit_fiche_espace") {
        document
          .getElementById("col-" + this.conIndex + "-" + this.colIndex)
          .classList.add("temp-bloc-deselect");
      }
    },
    away(e) {
      if (
        e.target.classList.contains("focused") ||
        e.target.classList.contains("content-editor") ||
        e.target.classList.length === 0 ||
        e.target.classList.contains("icon-btn") ||
        e.target.classList.contains("input-group") ||
        e.target.classList.contains("form-control") ||
        e.target.classList.contains("cedit") ||
        e.target.classList.contains("hu-color-picker") ||
        e.target.classList.contains("bloctr")
      ) {
        return;
      }

      this.removeHandle();
      this.selected = null;
      this.colSelected = null;
      this.valselected = null;

      if (
        document.getElementById("col-" + this.conIndex + "-" + this.colIndex)
      ) {
        if (
          document
            .getElementById("col-" + this.conIndex + "-" + this.colIndex)
            .querySelector(".thecolselected")
        ) {
          document
            .getElementById("col-" + this.conIndex + "-" + this.colIndex)
            .querySelector(".thecolselected")
            .classList.remove("thecolselected");
        }

        document
          .getElementById("col-" + this.conIndex + "-" + this.colIndex)
          .classList.remove("temp-bloc-deselect");
        document
          .getElementById("col-" + this.conIndex + "-" + this.colIndex)
          .classList.remove("temp-col-deselect");
        document
          .getElementById("col-" + this.conIndex + "-" + this.colIndex)
          .querySelector(".container-controls")
          .classList.add("d-none");
      }
    },
    handleElementUpdate(data) {
      this.updateElement({
        conindex: this.tConIndex,
        colindex: this.tColIndex,
        elindex: this.tElIndex,
        data,
      });
    },
    handleDataValueChange(key) {
      this.$refs[`input-${key}`][0].blur();
      const { ligne, onglet } = this.getFicheInfo();
      const payload = {
        onglet,
        ligne,
        headerKey: key,
        valeur: removeHtmlTag(this.$refs[`input-${key}`][0].innerHTML).trim(),
      };

      this.updatedValue[key] = payload;

      this.changedValue = Object.keys(this.updatedValue).map(
        (key) => this.updatedValue[key]
      );

      if (!this.isProjectTemplate()) {
        this.changedValue.forEach((el) => {
          this.syncDataValue(el);
        });
      }

      this.setAddedToFiche({ headerKey: this.deletedData, value: false });

      this.updateElement({
        conindex: this.conIndex,
        colindex: this.colIndex,
        elindex: this.elindex,
        data: this.element,
      });

      if (document.querySelector(".temp-bloc-deselect")) {
        // document.querySelector('.temp-bloc-deselect').classList.remove('temp-bloc-deselect')
      }

      this.selected = null;
    },
    handleDrag(data) {
      this.element.childElements = data;
    },
    deleteData(index) {
      const key = this.element.childElements[index].key;
      this.deletedData.push(key);
      this.element.childElements.splice(index, 1);

      if (!this.isProjectTemplate()) {
        this.addDeletedHeader(this.deletedData);
      }

      this.setAddedToFiche({ headerKey: this.deletedData, value: false });

      eventBus.$emit("myDeleted", key);
    },
    removeHandle() {
      var handles = document.querySelectorAll(".the-handle");

      for (var j = 0; j < handles.length; j++) {
        handles[j].classList.remove("show");
      }

      var colSelected = document.querySelectorAll(".cedit");

      for (var i = 0; i < colSelected.length; i++) {
        colSelected[i].classList.remove("thecolselected");
      }
    },
    toggleCurrentColumn(key, e, context, index) {
      let allCols = document.querySelectorAll(".top-level-col");

      for (var i = 0; i < allCols.length; i++) {
        allCols[i].classList.remove("temp-bloc-deselect");
        allCols[i].classList.remove("temp-col-deselect");
        allCols[i].querySelector(".container-controls").classList.add("d-none");

        if (allCols[i].querySelector(".thecolselected")) {
          allCols[i]
            .querySelector(".thecolselected")
            .classList.remove("thecolselected");
        }
      }

      var topAction = document.querySelectorAll(".top-action");

      if (topAction.length > 0) {
        for (var j = 0; j < topAction.length; j++) {
          topAction[j].classList.add("d-none");
        }
      }

      this.removeHandle();

      if (this.$route.name === "edit_fiche_espace") {
        if (context === "value") {
          this.selected = key;
          this.contentEditable = true;
          this.valselected = key;
          this.colselected = null;
        } else {
          this.colselected = key;
          this.colSelected = key;
          this.valselected = null;
        }

        // if (document.getElementById('text-' + this.conIndex + '-' + this.colIndex)) {
        //   document.getElementById('text-' + this.conIndex + '-' + this.colIndex).classList.remove('focused')
        // }

        let textEditable = document.querySelectorAll(".text-editable");

        if (textEditable.length > 0) {
          for (let i = 0; i < textEditable.length; i++) {
            textEditable[i].classList.remove("focused");
          }
        }

        var zoneTextFocused = document.querySelectorAll(".text-editable");

        if (zoneTextFocused.length > 0) {
          for (var j = 0; j < zoneTextFocused.length; j++) {
            zoneTextFocused[j].classList.remove("focused");
          }
        }

        var cedit = document.querySelectorAll(".cedit");

        if (cedit.length > 0) {
          for (var j = 0; j < cedit.length; j++) {
            cedit[j].classList.remove("thecolselected");
          }
        }

        var handle = document.querySelectorAll(".the-handle");

        if (handle.length > 0) {
          for (var j = 0; j < handle.length; j++) {
            handle[j].classList.remove("show");
          }
        }

        let allCols = document.querySelectorAll(".top-level-col");

        for (var i = 0; i < allCols.length; i++) {
          allCols[i].classList.remove("columnActive");
        }

        let letAllContainers = document.querySelectorAll('[role="conteneur"]');

        for (var i = 0; i < letAllContainers.length; i++) {
          letAllContainers[i].classList.remove("container-active");
        }

        var containerControls = document.querySelectorAll(".for-container");
        console.log(containerControls);
        for (let j = 0; j < containerControls.length; j++) {
          containerControls[j].classList.add("d-none");
        }

        var btngroups = document.querySelectorAll(".my-btn-group");
        for (let k = 0; k < btngroups.length; k++) {
          btngroups[k].classList.add("inactive");
        }

        if (
          document.getElementById("col-" + this.conIndex + "-" + this.colIndex)
        ) {
          document
            .getElementById("col-" + this.conIndex + "-" + this.colIndex)
            .classList.add("temp-bloc-deselect");
          document
            .getElementById("col-" + this.conIndex + "-" + this.colIndex)
            .classList.add("temp-col-deselect");
          document
            .getElementById("col-" + this.conIndex + "-" + this.colIndex)
            .querySelector(".container-controls")
            .classList.remove("d-none");
        }

        document
          .getElementById("col-" + this.conIndex + "-" + this.colIndex)
          .closest('[role="conteneur"]')
          .querySelector(".top-action")
          .classList.remove("d-none");
        document
          .getElementById("col-" + this.conIndex + "-" + this.colIndex)
          .closest('[role="conteneur"]')
          .querySelector(".my-btn-group")
          .classList.remove("d-none");
        // document.getElementById('col-' + this.conIndex + '-' + this.colIndex).closest('[role="conteneur"]').querySelector('.container-controls').classList.remove('d-none')

        var toolbarButtons = document.querySelectorAll(".disabled-action");
        e.target
          .closest(".handle-wrapper")
          .querySelector(".the-handle")
          .classList.add("show");

        for (let i = 0; i < toolbarButtons.length; i++) {
          toolbarButtons[i].classList.remove("disabled-action");
        }

        setTimeout(() => {
          this.tempIndex = index;
          eventBus.$emit("selected", {
            element: this.element,
            index: index,
            type: "content",
            conIndex: this.conIndex,
            colIndex: this.colIndex,
            elindex: this.elindex,
            context: context,
          });
        }, 500);
      } else {
        this.contentEditable = false;
      }
    },
    formatNumber(n, dp = 2) {
      let e = "";
      let s = e + n;
      let l = s.length;
      let b = n < 0 ? 1 : 0;
      let i = s.lastIndexOf(".");
      if (i === -1) {
        dp = 0;
      }
      let j = i === -1 ? l : i;
      let r = e;
      let d = s.substr(j + 1, dp);
      while ((j -= 3) > b) {
        r = " " + s.substr(j, 3) + r;
      }
      return (
        s.substr(0, j + 3) +
        r +
        (dp
          ? "." + d + (d.length < dp ? "00000".substr(0, dp - d.length) : e)
          : e)
      );
    },
    formatStyle(style) {
      let res;
      if (typeof style !== "undefined") {
        switch (style.justifyContent) {
          case "flex-start":
            res = { ...style, textAlign: "left" };
            break;
          case "center":
            res = { ...style, textAlign: "center" };
            break;
          case "flex-end":
            res = { ...style, textAlign: "right" };
            break;
          default:
            res = { ...style, textAlign: "justify" };
            break;
        }
      }

      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.bloc-value {
  /*height:24px;*/
}
.bloc-value span:focus {
  outline: none !important;
  box-shadow: 0 0 2px 1px #9395c1;
}

.bloc-value span span {
  height: 22px !important;
  width: 100%;
  display: inline-block;
  line-height: 22px;
}

.bloc-value {
  line-height: 11px !important;
}

.thecolselected,
thecolselected:focus,
.valselected {
  outline: none !important;
  box-shadow: 0 0 2px 1px #9395c1;
}
.cedit,
.thecolselected {
  line-height: 11px !important;
}
.bloc-title {
  width: 290px !important;
}
.the-handle {
  position: absolute;
  display: none;
  left: -71px;
  top: -2px;
  z-index: 999999;
}
.show {
  display: block;
}
.the-handle.show {
}
.the-handle ul li {
  display: inline-block;
}
.the-handle button {
  background: #9395c1;
  padding: 0 5px;
  font-size: 11px;
  color: #fff;
  border-radius: 0;
  width: 35px;
  height: 24px;
  border: none;
}
.handle-wrapper {
  position: relative;
}
.cedit {
  display: inline-block;
  width: 100%;
}
.bloc-donnees {
  table-layout: fixed;
  width: 100%;
  tr {
    td {
      padding: 0;
      width: 100%;
      /*overflow:hidden;*/
      span {
        /*height: 100%;*/
        /*flex-wrap: wrap;*/
        /*align-items: center;*/
      }
    }
    td:first-child {
      color: #444444;
      font-size: 12px;
      line-height: 23px;
    }
    td:last-child {
      color: #2b3085;
      font-size: 14px;
      line-height: 23px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/display/blocDonneesElement.vue